import { Loader } from "pixel";
import { useMemo } from "react";
import appConfig from "../../config/appConfig";
import { FpApiProvider } from "./FpApiProvider";

const FpApiProviderWrapper = ({ children }: { children: React.ReactNode }) => {
  const apiConfig = appConfig?.api;

  const adminConfig = useMemo(() => {
    return {
      apiBaseUrl: apiConfig?.api_base_url,
      appBackendBaseUrl: apiConfig?.app_backend_base_url,
    };
  }, [apiConfig]);

  return apiConfig ? (
    <FpApiProvider userType={"ADMIN"} customFPConfig={adminConfig}>
      {children}
    </FpApiProvider>
  ) : (
    <Loader variant="fullpage" />
  );
};
export default FpApiProviderWrapper;
